'use strict';

module.exports = function () {
    $('body').on('click', '.scroll-animate', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        if ($(target).length) {
            $('html,body').animate({scrollTop: $(target).offset().top - $('.site-header').height()}, 500);
        }
    });
}
